import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  ButtonToolbar,
  Checkbox,
  FlexboxGrid,
  Form,
  SelectPicker,
  CheckPicker,
} from "rsuite";

import "./FollowupFilters.css";
import { updateIn } from "json-immut";
import { HelperServices } from "../../../core/services/HelperServices";
import { FollowupServices } from "../../../core/services/FollowupServices";
import { get } from "lodash/fp";
import { FollowupListParams } from "./FollowupDataTypes";
import {
  statusObjArr,
  foodTypeObjArr,
  availableOnDayObjArr,
  sizeObjArr,
  followupStatusObj,
  followupForObjArr,
  followupStatusObjArr,
  dateIntervalObjArr,
} from "../../../core/config/AppConstants";

import { isNotEmpty } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";

export interface PropTypesInterface {
  onSubmit: Function;
  onClear: Function;
  customerId: string;
}

export default function FollowupFilters({
  onSubmit,
  onClear,
  customerId,
}: PropTypesInterface) {
  const { t } = useTranslation();
  const initSearchFormData = {
    company: "",
    customer: customerId.toString(),
    user: "",
    title: "",
    follow_up_for: "",
    follow_up_status: followupStatusObj.incomplete.value,
    follow_up_date_from: "",
    follow_up_date_to: "",
    follow_up_date: "",
    date_interval_type: "",
    smart_search: "",
  };
  const [formData, setFormData] =
    useState<FollowupListParams>(initSearchFormData);
  const [showFilter, setShowFilter] = useState(false);
  const handleSearchToggle = () => setShowFilter(!showFilter);

  function handleFormChanges(data: any) {
    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  }

  async function init() {
    try {
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    init();
  }, []);

  function clearSearch() {
    handleFormChanges({
      path: "available_on_day",
      value: "",
    });
    onClear();
    setFormData(initSearchFormData);
  }

  return (
    <div>
      <div className="row mb-2">
        <ButtonToolbar className="mb-hide">
          <Button onClick={handleSearchToggle}>{t("ADVANCE_SEARCH")}</Button>
        </ButtonToolbar>
      </div>
      {showFilter && (
        <div className="content mb-2">
          <Form
            formValue={formData}
            onChange={(data: any) => {
              let form = { ...formData, ...data };
              setFormData(form);
            }}
            layout="inline"
          >
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="follow_up_for">
                  <Form.ControlLabel>
                    {t("FOLLOWUP")} {t("FOR")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={followupForObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "follow_up_for", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "follow_up_for", value: "" });
                    }}
                    name="follow_up_for"
                    value={formData?.follow_up_for}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="follow_up_status">
                  <Form.ControlLabel>
                    {t("FOLLOWUP")} {t("STATUS")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={followupStatusObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "follow_up_status", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "follow_up_status",
                        value: "",
                      });
                    }}
                    name="follow_up_status"
                    value={formData?.follow_up_status}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="date_interval_type">
                  <Form.ControlLabel>
                    {t("DATE")} {t("INTERVAL")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={dateIntervalObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "date_interval_type", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "date_interval_type",
                        value: "",
                      });
                    }}
                    name="date_interval_type"
                    value={formData?.date_interval_type}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <div className="filter-btn mt-4 mb-2">
                  <Button onClick={() => clearSearch()}>
                    {t("CLEAR_FILTER")}
                  </Button>
                  <Button onClick={() => onSubmit(formData)}>
                    {t("SEARCH")}
                  </Button>
                </div>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </Form>
        </div>
      )}
    </div>
  );
}
